import moment from 'moment';
import { HospitalDoctor, Notification, PimsUser, isPendoActive } from '../utils/dataTypes';
import { generateDateSort } from '../utils/sortFuncs';
import { pimsApi } from './pimsApi';

// Define a service using a base URL and expected endpoints
export const userApi = pimsApi.injectEndpoints({
	endpoints: (builder) => ({
		getPimsUser: builder.query<PimsUser, number>({
			query: (user_id) => `user/${user_id}`,
			providesTags: (result, error, id) => [{ type: 'User', id: id }],
			transformResponse: (response: { data: PimsUser }) => response.data,
		}),
		getPimsUsers: builder.query<PimsUser[], void>({
			query: () => 'user',
			providesTags: (result, error, id) => [{ type: 'User', id: 'List' }],
			transformResponse: (response: { data: PimsUser[] }) => response.data,
		}),
		getDoctorsInMyHospital: builder.query<HospitalDoctor[], void>({
			query: () => 'hospital/doctor',
			providesTags: (result, error, id) => [{ type: 'HospitalDoctor', id: 'List' }],
			transformResponse: (response: { data: HospitalDoctor[] }) => response.data,
		}),
		getNotifications: builder.query<Notification[], null>({
			query: () => `notifications`,
			providesTags: (result, error, id) => [
				{ type: 'Notification', id: 'LIST' },
			],
			transformResponse: (response: { data: Notification[] }) => {
				const dateSort = generateDateSort('received_at', 'desc');
				const MOCK_RESPONSE_DATA: Notification[] = [
					{
						id: 1,
						pet_id: '1ef66d10942c4c7f83822cc24b40d2ba',
						sender_id: 1,
						sender_type: 'owner',
						received_at: parseInt(moment().format('x')),
						read: false,
						message: 'Hello world',
					},
					{
						id: 2,
						pet_id: '86e2b41d43234d3c95660aacf4615cb1',
						sender_id: 2,
						sender_type: 'owner',
						received_at: parseInt(
							moment()
								.subtract(
									Math.floor(Math.random() * 60),
									'hour',
								)
								.format('x'),
						),
						read: true,
						message:
							'**Hello world** This is a long message very long way more than 50 chars. \n ## NEW LINE \n**Hello world** This is a long message very long way more than 50 chars.',
					},
					{
						id: 3,
						pet_id: '24f7b3ff06fc4daba7909696798ae060',
						sender_id: 44,
						sender_type: 'owner',
						received_at: parseInt(
							moment()
								.subtract(
									Math.floor(Math.random() * 15),
									'hour',
								)
								.format('x'),
						),
						read: false,
						message: '## header',
					},
					{
						id: 4,
						pet_id: '848ab787a6f34799b9424e1904f9fcfc',
						sender_id: 44,
						sender_type: 'owner',
						received_at: parseInt(
							moment()
								.subtract(
									Math.floor(Math.random() * 15),
									'hour',
								)
								.format('x'),
						),
						read: false,
						message: '## header',
					},
					{
						id: 5,
						pet_id: '86e2b41d43234d3c95660aacf4615cb1',
						sender_id: 2,
						sender_type: 'owner',
						received_at: parseInt(
							moment()
								.subtract(Math.floor(Math.random() * 2), 'hour')
								.format('x'),
						),
						read: false,
						message: 'This is unread!',
					},
					{
						id: 6,
						pet_id: '86e2b41d43234d3c95660aacf4615cb1',
						sender_id: 2,
						sender_type: 'owner',
						received_at: parseInt(
							moment()
								.subtract(Math.floor(Math.random()), 'hour')
								.format('x'),
						),
						read: false,
						message: '**Also unread!**',
					},
				];

				MOCK_RESPONSE_DATA.sort(dateSort);

				return MOCK_RESPONSE_DATA;
			},
		}),

		getPendoStatus: builder.query<isPendoActive, null>({
			query: () => `pendo`,
			transformResponse: (response: { data: isPendoActive }) => response.data,
		}),

	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const {
	useGetPimsUserQuery,
	useGetPimsUsersQuery,
	useGetDoctorsInMyHospitalQuery,
	useGetNotificationsQuery,
	useGetPendoStatusQuery
} = userApi;
